import React from "react";
import { Paper, Box, Typography, Chip } from "@mui/material";
import PaymentIcon from "@mui/icons-material/Payment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

const PagosCard = ({ pagos }) => {
  const totalPagado = pagos.reduce((sum, pago) => sum + parseFloat(pago.importe || 0), 0);
  
  // Iconos por tipo de pago
  const getIconoPorMedio = (medioId) => {
    switch(medioId) {
      case 1: // Efectivo
        return <AttachMoneyIcon sx={{ fontSize: 12 }} />;
      case 7: // Tarjeta Crédito
      case 8: // Tarjeta Débito
        return <CreditCardIcon sx={{ fontSize: 12 }} />;
      case 99: // Cuenta Corriente
        return <AccountBalanceIcon sx={{ fontSize: 12 }} />;
      default:
        return <PaymentIcon sx={{ fontSize: 12 }} />;
    }
  };

  // Color por tipo de pago
  const getColorPorMedio = (medioId) => {
    switch(medioId) {
      case 1: return "#27ae60"; // Verde para efectivo
      case 7: return "#3498db"; // Azul para tarjeta
      case 8: return "#2980b9"; // Azul oscuro para débito
      case 99: return "#9b59b6"; // Púrpura para cuenta corriente
      default: return "#95a5a6"; // Gris para otros
    }
  };

  return (
    <Paper sx={{ 
      p: 1,
      bgcolor: "#fff",
      border: "1px solid #e0e0e0",
      borderRadius: 1,
      height: '100%'
    }}>
      {/* Header */}
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <PaymentIcon sx={{ fontSize: 16, color: "#757575" }} />
          <Typography variant="caption" fontWeight="bold" color="text.secondary">
            PAGOS ({pagos.length})
          </Typography>
        </Box>
        <Typography variant="caption" fontWeight="bold" color="primary">
          ${totalPagado.toFixed(2)}
        </Typography>
      </Box>

      {/* Lista de pagos */}
      <Box sx={{ 
        maxHeight: 110, 
        overflowY: "auto",
        pr: 0.5,
        '&::-webkit-scrollbar': {
          width: 4,
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: 2,
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#bdbdbd',
          borderRadius: 2,
        }
      }}>
        {pagos.map((pago, index) => (
          <Box
            key={pago.id}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              py: 0.4,
              borderBottom: index < pagos.length - 1 ? "1px dashed" : "none",
              borderColor: "#e0e0e0",
            }}
          >
            {/* Icono y nombre del medio */}
            <Box display="flex" alignItems="center" gap={0.5} sx={{ flex: 1 }}>
              <Box sx={{ color: getColorPorMedio(pago.medio_pago) }}>
                {getIconoPorMedio(pago.medio_pago)}
              </Box>
              <Box>
                <Typography variant="caption" sx={{ lineHeight: 1.1 }}>
                  {pago.nombre?.substring(0, 20)}
                </Typography>
                {pago.detalle && (
                  <Typography variant="caption" color="text.secondary" sx={{ 
                    display: 'block', 
                    fontSize: '0.6rem',
                    lineHeight: 1
                  }}>
                    {pago.detalle}
                  </Typography>
                )}
              </Box>
            </Box>
            
            {/* Importe */}
            <Typography 
              variant="caption" 
              fontWeight="medium" 
              sx={{ 
                ml: 0.5, 
                textAlign: 'right',
                minWidth: 45,
                fontFamily: 'monospace'
              }}
            >
              ${parseFloat(pago.importe || 0).toFixed(2)}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Información de fecha si existe */}
      {/* {pagos.length > 0 && pagos[0].created_at && (
        <Box 
          sx={{ 
            mt: 0.75, 
            pt: 0.5, 
            borderTop: '1px dashed #e0e0e0'
          }}
        >
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
            Pagado el: {new Date(pagos[0].created_at).toLocaleDateString('es-AR')}
          </Typography>
        </Box>
      )} */}
    </Paper>
  );
};

export default PagosCard;